import {
  EMPLOYER_CASE_NOTE_ADD_NEW,
  EMPLOYER_CASE_NOTE_ADD_NEW_SUCCESS,
  EMPLOYER_CASE_NOTE_ADD_NEW_ERROR,
  EMPLOYER_CASE_NOTE_DELETE,
  EMPLOYER_CASE_NOTE_DELETE_ERROR,
  EMPLOYER_CASE_NOTE_DELETE_SUCCESS,
  EMPLOYER_CASE_NOTE_EDIT,
  EMPLOYER_CASE_NOTE_EDIT_ERROR,
  EMPLOYER_CASE_NOTE_EDIT_SUCCESS,
  EMPLOYER_CASE_NOTE_GET_BY_ID,
  EMPLOYER_CASE_NOTE_GET_BY_ID_ERROR,
  EMPLOYER_CASE_NOTE_GET_BY_ID_SUCCESS,
  EMPLOYER_CASE_NOTE_GET_LIST,
  EMPLOYER_CASE_NOTE_GET_LIST_ERROR,
  EMPLOYER_CASE_NOTE_GET_LIST_SUCCESS,
  EMPLOYER_CASE_NOTE_ADD_NEW_REQUEST,
  EMPLOYER_CASE_NOTE_QUERY,
  EMPLOYER_CASE_NOTE_QUERY_SUCCESS,
  EMPLOYER_CASE_NOTE_QUERY_ERROR,
} from '../actions';

const initialState = {
  caseNotes: [],
  caseNote: null,
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case EMPLOYER_CASE_NOTE_GET_BY_ID:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case EMPLOYER_CASE_NOTE_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNote: payload,
      };

    case EMPLOYER_CASE_NOTE_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };

    case EMPLOYER_CASE_NOTE_QUERY:
    case EMPLOYER_CASE_NOTE_GET_LIST:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case EMPLOYER_CASE_NOTE_QUERY_SUCCESS:
    case EMPLOYER_CASE_NOTE_GET_LIST_SUCCESS:
      return {
        ...state,
        caseNotes: payload,
        loading: true,
      };
    case EMPLOYER_CASE_NOTE_ADD_NEW:
      return {
        ...state,
        loading: false,
        error: null,
        addSuccess: false,
      };

    case EMPLOYER_CASE_NOTE_ADD_NEW_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNote: payload,
        caseNotes: state.caseNotes.concat(payload),
        addSuccess: true,
      };

    case EMPLOYER_CASE_NOTE_EDIT:
      return {
        ...state,
        loading: false,
        error: null,
        editSuccess: false,
      };
    case EMPLOYER_CASE_NOTE_EDIT_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNotes: state.caseNotes.map(c => {
          return c.id === payload.id ? payload : c;
        }),
        caseNote: payload,
        error: null,
        editSuccess: true,
      };
    case EMPLOYER_CASE_NOTE_DELETE:
      return {
        ...state,
        loading: false,
        error: null,
        deleteSuccess: false,
      };
    case EMPLOYER_CASE_NOTE_DELETE_SUCCESS:
      return {
        ...state,
        loading: true,
        caseNotes: state.caseNotes.filter(c => c.id !== payload),
        deleteSuccess: true,
      };
    case EMPLOYER_CASE_NOTE_QUERY_ERROR:
    case EMPLOYER_CASE_NOTE_DELETE_ERROR:
    case EMPLOYER_CASE_NOTE_ADD_NEW_ERROR:
    case EMPLOYER_CASE_NOTE_EDIT_ERROR:
    case EMPLOYER_CASE_NOTE_GET_BY_ID_ERROR:
    case EMPLOYER_CASE_NOTE_GET_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
